module.exports = __webpack_public_path__ + "img/customer-icon-9.00de50a1.png";